

























































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, Watch } from 'vue-property-decorator'
import { MenuStore } from '@/modules/common/layout/store/menu.store'

@Component
export default class MenuExpandable extends Vue {
  constructor(
    protected readonly menuStore: MenuStore
  ) {
    super()
  }

  @Prop() label!: string
  @Prop() mini!: boolean
  @Prop({ default: false }) expand: boolean

  openMiniMenu = false
  toggleSubMenuItem = false

  get isMiniDrawer_or_forceClose() {
    return this.menuStore.miniDrawer || this.menuStore.forceClose
  }

  @Watch('expand', { immediate: true })
  onExpandStateChange(newState) {
    if (typeof newState === 'boolean') {
      this.toggleSubMenuItem = newState
    }
  }

  toggleMiniMenu() {
    //is miniDrawer or forceClose
    //toggle miniMenu
    if (this.isMiniDrawer_or_forceClose) {
      this.openMiniMenu = !this.openMiniMenu
    }
  }

  toggleSubMenu() {
    this.toggleSubMenuItem = !this.toggleSubMenuItem
  }

}
